import { driver } from "driver.js";

export const driverJs = driver({
  allowClose: true,
  steps: [
    {
      element: "#select-country",
      popover: {
        title: "Step 1",
        description: "Select your country",
        align: "end",
      },
    },
    {
      element: "#select-grading-scale",
      popover: {
        title: "Step 2",
        description: "Select your grading scale",
      },
    },
    {
      element: "#select-country",
      popover: {
        title: "Step 3",
        description: "Let's explore the new Custom Scales feature! We'll open the country dropdown to show you.",
        align: "end",
      },
      onHighlighted: () => {
         
        const countryButton = document.getElementById("select-country");
        if (countryButton) {
          countryButton.click();
        }
      },
    },
    {
      element: "#custom-scales-option",
      popover: {
        title: "Step 4",
        description: "🎨 New Feature! This is the 'My Custom Scales' option. Instead of using country-based grading scales, you can create and use your own custom grading scales.",
        align: "start",
      },
      onHighlighted: () => {
        
        setTimeout(() => {
          const countryButton = document.getElementById("select-country");
          const customOption = document.getElementById("custom-scales-option");
          if (countryButton && !customOption?.offsetParent) {
            countryButton.click();
          }
        }, 100);
      },
    },
    {
      element: "#custom-scales-option",
      popover: {
        title: "Step 5",
        description: "When you click 'My Custom Scales', it switches to custom mode where you can select from your created scales or create new ones. This gives you complete control over your grading system!",
        align: "start",
      },
      onHighlighted: () => {
        setTimeout(() => {
          const countryButton = document.getElementById("select-country");
          const customOption = document.getElementById("custom-scales-option");
          if (countryButton && !customOption?.offsetParent) {
            countryButton.click();
          }
        }, 100);
      },
    },
    {
      element: "#select-mode",
      popover: {
        title: "Step 6",
        description: "Select mode between AI and Manual",
      },
    },
    {
      element: "#upload-transcript",
      popover: {
        title: "Step 7",
        description: "Upload your transcript",
      },
    },
    {
      element: "#gpa-scale-table",
      popover: {
        title: "Step 8",
        description: "This is the GPA scale table",
      },
    },
    {
      element: "#history-sidebar-items",
      popover: {
        title: "Step 9",
        description: "History sidebar for viewing previous conversions",
      },
    },
    {
      element: "#credit-counter",
      popover: {
        title: "Step 10",
        description: "Track Credits Available",
      },
    },
    {
      element: "#pricing-dialog",
      popover: {
        title: "Step 11",
        description: "Pricing plans",
      },
    },
  ],
  onPopoverRender: (popover) => {
    if (popover.footer.querySelector(".driver-skip-button")) {
      return;
    }

    const skipButton = document.createElement("button");
    skipButton.className = "driver-skip-button";
    skipButton.textContent = "Skip Tour";

    skipButton.onclick = () => {
      driverJs.destroy();
    };

    skipButton.style.marginRight = "auto";

    skipButton.style.border = "solid";
    skipButton.style.background = "transparent";
    skipButton.style.cursor = "pointer";
    skipButton.style.color = "#777";

    if (popover.footer) {
      popover.footer.prepend(skipButton);
      popover.footer.style.display = "flex";
    }
  },
});
